"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _config = require("webmotors-react-pj/config");
var _style = require("webmotors-react-pj/frame/modal/store/search/style");
var _lang = _interopRequireDefault(require("webmotors-react-pj/i18n/lang"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var _default = _ref => {
  let {
    onSearch
  } = _ref;
  return _react.default.createElement(_style.StyleContainer, null, _react.default.createElement(_style.StyleInputSearch, {
    placeholder: _lang.default.header.searchStore,
    type: "text",
    name: 'searchDealer',
    onKeyUp: e => onSearch(e.target.value),
    iconLeft: "".concat(_config.UrlCockpit, "/assets/img/icons/search1.svg")
  }));
};
exports.default = _default;